import React, {useContext, useEffect, useState} from 'react'
import t from 'helpers/I18n'

import PropTypes from 'prop-types'
import {AppDataContext} from 'contexts/app-data'

import BaseParagraph from "../../base-components/base-paragraph";
import { useHistory } from 'react-router-dom';
import StepsLoader from "../steps-loader";
import InputField from "../../base-components/base-input";
import { HiOutlineLightBulb } from 'react-icons/hi'
import BottomSheet from '../../modals/bottom-sheet';




const HasEnterprise = ({_step_service, step_ID, step_URL, next_step, setDataToContext, getDataFromContext, getStep}) => {
    const name = step_ID
    const history = useHistory();
    const data = getDataFromContext(step_ID)
    
    const {state, dispatch} = useContext(AppDataContext)
    const [inputData, setInputData] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
  
    const [nextTick, setNextTick] = useState(false)
    const [savedData, setSavedData] = useState({})


    const getInputValue = (name, value) => {
        setInputData({
            ...inputData,
            [name] : value
        })
    }

    const action = () => {
        _step_service({step_ID, setIsLoading, next_step})
    }

    useEffect(() => {
        // if(inputData[name] != savedData["has_enterprise"]) {
        //     setDataToContext("establishment_date", "", 'establishment_date',  "NULL");
        //     setDataToContext("enterprise_name", "", 'enterprise_name', "");
        //     setDataToContext("enterprise_name", "", "enterprise_name_use_fullname", 0);
        // }
        
        if (inputData[name] === 0 || inputData[name] === 1) {
            setDataToContext(step_ID, step_URL, name, inputData[name])
            setNextTick(nextTick => !nextTick)
        }
    }, [inputData])

    useEffect(() => {
        if (inputData[name] === 0) {
        _step_service({step_ID, setIsLoading, next_step: 'enterprise-name'})
        }
      if (inputData[name] === 1) {
        _step_service({step_ID, setIsLoading, next_step: 'enterprise-number'})

        }
    }, [nextTick])


    useEffect(() => {
        getStep(['has_enterprise']).then(res => {
            setSavedData(res)
        })
            
        if (window.PageBus) {
                window.PageBus.publish("analyticsServices", {
                pageID: "onboarding",
                stepSeq: "3",
                stepName: "pro info:are you registered at bce",
                flowType: "sales",
                flowName: "onboarding",
                productName: "onboarding",
                trackMethod: "flow"
                }
            );
        }
     }, [])

    return (
        <>
            <StepsLoader loading={isLoading}>
                <BaseParagraph>
                    <h3>{t('pro_infos.pro_info_are_you_registered_at_bc.title')}</h3>
                </BaseParagraph>
          
                <a className={"link"} onClick={() => setShowModal(true)}>
                <HiOutlineLightBulb />
                <span>{t('pro_infos.pro_info_are_you_registered_at_bc.tool_tip')}</span>
                </a>
                <br/>
                <br/>

                <InputField type={"select"} name={name}
                    options={[
                        {value:1, label: t('general.yes')},
                        {value:0, label:t('general.no')}
                        ]}
                    getInputValue={getInputValue}
                    defaultSelect={savedData && Number(savedData[step_ID])}
                />
                {showModal &&
                    <BottomSheet
                        title={""}
                        close={() => {setShowModal(false)}}
                    >
                        <BaseParagraph>
                            <p>{t('pro_infos.pro_info_are_you_registered_at_bc.modal.text')}</p>

                        </BaseParagraph>
                    </BottomSheet>
                }
            </StepsLoader>
        </>
    )
}

HasEnterprise.propTypes = {
    step_ID: PropTypes.string,
    step_URL: PropTypes.string,
    next_step: PropTypes.string,
    setDataToContext: PropTypes.any,
    getDataFromContext: PropTypes.any,
    step_form: PropTypes.array,
    error: PropTypes.array,
    _step_service: PropTypes.func,
}


export default HasEnterprise